module.exports = __webpack_public_path__ + "static/media/messages.686c43c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/messages.svg
// module id = 108
// module chunks = 0